import { request } from '@aqx-core/common/request';

import { ICompanyExposure, ICompanyExposureParams } from '../model';

export default {
  getCompanyExposure: (params?: ICompanyExposureParams, signal?: AbortSignal) =>
    request.get<ICompanyExposure[]>('/api/dealer/v1/company/exposure', {
      params,
      signal
    })
};
